!(function (e) {
    var t,
        n,
        d,
        o,
        i,
        a,
        r = `<svg>
    <symbol id="icon-web__jiangli" viewbox="0 0 1024 1024" fill="currentColor">
        <path d="M915.136 264.558h-86.23c8.067-4.393 15.252-8.837 21.096-13.245 32.68-24.654 45.224-75.14 29.182-117.434-8.446-22.266-23.924-40.33-44.76-52.236-22.619-12.925-50.516-18.184-82.898-15.625-68.363 5.396-127.917 24.652-172.228 55.684-25.911 18.147-46.975 40.42-62.605 66.2-0.728 1.2-1.429 2.42-2.133 3.635-0.704-1.215-1.405-2.435-2.132-3.634-15.63-25.78-36.693-48.054-62.605-66.201-44.31-31.032-103.866-50.288-172.228-55.684-32.387-2.558-60.28 2.7-82.898 15.625-20.836 11.908-36.315 29.971-44.76 52.237-16.044 42.294-3.497 92.78 29.183 117.433 5.9 4.451 13.157 8.891 21.308 13.245h-93.49c-16.497 0-29.87 13.374-29.87 29.87v195.86c0 16.497 13.373 29.87 29.87 29.87h38.716v362.29c0 40.532 30.973 73.508 69.044 73.508h592.678c38.07 0 69.044-32.976 69.044-73.509v-362.29h38.718c16.496 0 29.87-13.373 29.87-29.87v-195.86c-0.002-16.496-13.375-29.869-29.872-29.869z m-159.26-143.454c37.16-2.932 62.61 8.563 71.642 32.374 8.04 21.197 0.91 44.89-10.795 53.721-26.554 20.032-103.113 46.172-139.251 57.36H544.459c27.47-111.77 142.332-138 211.416-143.455zM212.396 207.2c-11.704-8.83-18.836-32.524-10.794-53.721 9.031-23.81 34.476-35.303 71.642-32.374 69.085 5.454 183.947 31.685 211.417 143.454H359.41l0.037-0.135c-43.374-11.955-121.65-38.063-147.05-57.224z m-80.071 112.618h350.8V464.9h-350.8V319.817z m65.909 562.63v-362.29h284.89v383.218H214.698c-8.924 0-16.463-9.585-16.463-20.929z m625.603 0c0 11.343-7.538 20.928-16.463 20.928H538.384V520.158h285.454v362.288z m65.91-417.548H538.383V319.817h146.699l0.05 0.167 0.559-0.167h204.055v145.082z"></path>
    </symbol>
    <symbol id="icon-shaixuan" viewbox="0 0 1024 1024" fill="currentColor">
        <path d="M855.342766 151.46262c-6.056949-11.851932-18.984377-19.393699-33.219589-19.393699L101.903901 132.068921c-14.360056 0-27.412326 7.704472-33.396621 19.744693-5.988388 12.015661-3.845585 26.157753 5.520737 36.192294l255.896134 274.308483 0 309.339324c0 12.847609 7.895831 24.602328 20.389376 30.328749l189.116195 86.432535c5.154393 2.371 10.771321 3.515057 16.33913 3.515057 6.541997 0 13.090133-1.607614 18.926048-4.797259 10.718109-5.945409 17.427928-16.503882 17.809621-28.037567l12.957103-396.767536 245.078765-274.90507C859.543438 177.316451 861.425298 163.313529 855.342766 151.46262zM520.773827 804.275693l-117.384477-53.647851L403.38935 483.628836l127.858016 0L520.773827 804.275693zM550.774095 416.986019c-1.963725-0.299829-3.761674-1.090844-5.809309-1.090844L383.519814 415.895175 181.938726 199.803605l562.427506 0L550.774095 416.986019zM685.454494 524.008498l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 654.104485l273.392624 0 0 59.759035-273.392624 0 0-59.759035ZM685.454494 773.618463l273.392624 0 0 59.759035-273.392624 0 0-59.759035Z"></path>
    </symbol>
</svg>`;
    function c() {
        i || ((i = !0), d());
    }
    (t = function () {
        var e, t, n;
        ((n = document.createElement('div')).innerHTML = r),
            (r = null),
            (t = n.getElementsByTagName('svg')[0]) &&
            (t.setAttribute('aria-hidden', 'true'),
                (t.style.position = 'absolute'),
                (t.style.width = 0),
                (t.style.height = 0),
                (t.style.overflow = 'hidden'),
                (e = t),
                (n = document.body).firstChild
                    ? (t = n.firstChild).parentNode.insertBefore(e, t)
                    : n.appendChild(e));
    }),
        document.addEventListener
            ? ['complete', 'loaded', 'interactive'].indexOf(document.readyState) > -1
                ? setTimeout(t, 0)
                : ((n = function () {
                    document.removeEventListener('DOMContentLoaded', n, !1), t();
                }),
                    document.addEventListener('DOMContentLoaded', n, !1))
            : document.attachEvent &&
            ((d = t),
                (o = e.document),
                (i = !1),
                (a = function () {
                    try {
                        o.documentElement.doScroll('left');
                    } catch (e) {
                        return void setTimeout(a, 50);
                    }
                    c();
                })(),
                (o.onreadystatechange = function () {
                    'complete' == o.readyState && ((o.onreadystatechange = null), c());
                }));
})(window);
